"use client";

import { useQuery } from "@tanstack/react-query";
import { Card, CardContent } from "@/components/ui/card";
import { searchApi } from "@/lib/api/services/search.api";

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <Card>
      <CardContent className="p-5 text-center">
        <p className="text-2xl font-bold text-foreground tabular-nums">{value}</p>
        <p className="mt-1 text-xs text-muted-foreground">{label}</p>
      </CardContent>
    </Card>
  );
}

export function AISearchStats() {
  const { data: stats, isLoading: statsLoading } = useQuery({
    queryKey: ["ai-search-stats"],
    queryFn: async () => {
      const data = await searchApi.getStats();
      return (data as { stats?: Record<string, number> }).stats ?? {};
    },
  });

  if (statsLoading) {
    return (
      <>
        {[1, 2, 3].map((i) => (
          <Card key={i}>
            <CardContent className="p-5">
              <div className="h-4 w-16 bg-muted/10 rounded animate-pulse" />
              <div className="mt-2 h-3 w-20 bg-muted/10 rounded animate-pulse" />
            </CardContent>
          </Card>
        ))}
      </>
    );
  }

  return (
    <>
      <StatCard label="Articles" value={stats?.articles ?? 0} />
      <StatCard label="Blog Posts" value={stats?.blogs ?? 0} />
      <StatCard label="Research Reports" value={stats?.research ?? 0} />
    </>
  );
}